import { createFetch, accept, header, init } from 'http-client'

export default (...args) => {
  const { CSRF } = global
  if (!CSRF) {
    throw new Error('Unable to initialize fetch: no CSRF token set')
  }

  const fetch = createFetch(
    accept('application/json'),
    header('x-csrf-token', CSRF),
    header('content-type', 'application/json'),
    init('credentials', 'include')
  )

  return fetch(...args)
}



// WEBPACK FOOTER //
// ./lib/fetch.js